import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const ProjetComponent = ({
  // Le composant n'est pas fini
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group>
          <Form.Input
            name="identifiantProjet"
            key="identifiantProjet"
            label="Intitulé du projet"
            fluid
            width={16}
            value=""
            onChange={handleChange}
            data-testid="projetSubventionPanel"
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default ProjetComponent;
